<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <qr-edit-gateway
        v-if="showGatewayPopup"
        v-model="showGatewayPopup"
        :sections="specialInfoSingle"
        :form-data="data"
        @edit-all="handleEditAll"
        @save="qrUpdate"
        @cancel="onCancel"
      >
        <template v-slot:preview style="position: relative; min-height: 100%;">
          <div class="sticky-preview">
            <commercial-page
              v-model="data"
              :loading="loading || qrLoading"
              :qr-svg-data-url="qrSvgDataUrl"
            />
          </div>
        </template>
      </qr-edit-gateway>

      <!-- فرم اصلی و استپر (زمانی که Gateway بسته است) -->
      <v-card flat :disabled="qrLoading" v-if="!showGatewayPopup">
        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2 sticky-md" cols="12" md="4" style="top: 110px; height: fit-content;">
            <div class="sticky-preview">
              <commercial-page
                v-model="data"
                :loading="loading || qrLoading"
                :qr-svg-data-url="qrSvgDataUrl"
              />
            </div>
          </v-col>

          <v-col class="pa-2 px-0" cols="12" md="8">
            <v-card :disabled="loading" flat>
              <v-stepper
                v-model="e6"
                class="px-0 mx-0 qr-stepper"
                flat
                vertical
              >
                <!-- استپ 1 -->
                <v-stepper-step
                  :complete="e6 > 1"
                  class="px-0 px-md-4"
                  step="1"
                >
                  <div class="row justify-center">
                    <div class="col-md-12">
                      <p>اطلاعات</p>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="res.title"
                          :disabled="e6 > 2"
                          append-icon="mdi-pen"
                          class="mt-0 pt-0 contentinfo"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          label="نام مجتمع تجاری/اداری شما"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-res-title`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="نام مجتمع تجاری/اداری شما"
                        />
                      </div>
                    </div>
                    <div class="col-md-6 mt-0 pt-0">
                      <div class="rowinfo">
                        <qr-address-field
                          id="qr-address"
                          v-model="res.identifier"
                          :domain-id="res.domain_id"
                          :error-messages="errors['identifier']"
                          append-icon="mdi-web"
                          class="mt-0 pt-0 contentinfo"
                          dense
                          outlined
                          persistent-hint
                          readonly
                          :hint="$t('qrAddressUpdate.hints.allowedChars')"
                          :key="$t('qrAddressUpdate.hints.allowedChars')"

                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-res-identifier`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="آدرس کیوآر"
                        />
                      </div>
                    </div>
                  </div>
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                                    <div class="mb-4 mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>
                  <list-expansion
                    v-model="data"
                    :components="specialInfo"
                    :data="data"
                    flat
                    @save-required="AutoSave && qrUpdate(false)"
                  />

                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="e6 = 2"
                    />
                  </div>
                </v-stepper-content>

                <!-- استپ 2 -->
                <v-stepper-step
                  :complete="e6 > 2"
                  class="px-0 px-md-4"
                  step="2"
                >
                  وارد کردن اطلاعات صفحه کاری
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                  <list-expansion
                    v-model="data"
                    :components="specialInfo2"
                    :data="data"
                    flat
                  @save-required="AutoSave && qrUpdate(false)"
                  />

                  <div class="row mx-auto">
                    <div class="col-md-6">
                      <prev-btn :loading="loading" @click="e6 = 1" />
                    </div>

                    <div class="col-md-6">
                      <next-btn
                        :loading="loading"
                        style="background: #1b8d39"
                        @click="e6 = 3"
                      />
                    </div>
                  </div>
                </v-stepper-content>

                <!-- استپ 3 -->
                <v-stepper-step :complete="e6 > 3" class="px-0 px-md-4" step="3">
                  تنظیمات پرداخت
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
                  <commercial-manager
                    ref="qrShop"
                    :domain="dtUrl"
                    :loading.sync="loading"
                    :qr-id="qr_id"
                    @save-required="AutoSave && qrUpdate(false)"

                  />

                  <div class="row mx-auto">
                    <div class="col-md-6">
                      <prev-btn :loading="loading" @click="e6 = 2" />
                    </div>

                    <div class="col-md-6">
                      <next-btn
                        :loading="loading"
                        style="background: #1b8d39"
                        @click="qrUpdate(true)"
                      />
                    </div>
                  </div>
                </v-stepper-content>
              </v-stepper>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import commercialPage from "../components/view/commercialPage.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import commercialManager from "../components/manager/commercialManager.vue";
import bLogoSelect from "../components/view/bLogoSelect.vue";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";

import { Bus } from "@/main";
import { mapActions, mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editBpage",

  components: {
    QrCustomize,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    commercialPage,
    QrShopManager,
    commercialManager,
    bLogoSelect,
    QrEditGateway,
    HelpInfo,
    HelpInfoWrapper,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true', // مدیریت استیت پاپ‌آپ
      serviceName: "Qrland",
      componentName: "editBpage-c",
      helpData: [],
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      qrSvgDataUrl:'',
      createdId: null,
      shortId: null,
      loading: false,
      showDialog: false,
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qr_id: "",
      qrSize: "",
      dtUrl: null,
      domainId: "",
      qrShow: 1,
      res: {},
      data: {},
      svgMade: "",
      destinationUrl: "",
      qrLoading: false,
    };
  },

  mounted() {
    this.fetchData();

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
  },

  computed: {
    specialInfo() { 
      return [
        {
          name: "bannerSelector",
          value: "",
          title: this.$t("edit_bpage_special_info_special.upload_banner"),
          subtitle: "",
          icon: "image-area",
          model: "banner",
        },
        {
          name: "logoSelect",
          value: "",
          title: this.$t("edit_bpage_special_info_special.upload_logo"),
          subtitle: "",
          icon: "image-area",
          model: "logo",
        },
        {
          name: "Service",
          value: "",
          title: this.$t("edit_bpage_special_info_special.services"),
          subtitle: "",
          icon: "toolbox-outline",
          model: "service",
        },
        {
          name: "Faq",
          value: "",
          title: this.$t("edit_bpage_special_info_special.faq"),
          subtitle: "",
          icon: "help",
          model: "faq",
        },
        {
          name: "Blog",
          value: "",
          title: this.$t("edit_bpage_special_info_special.blog"),
          subtitle: "",
          icon: "text",
          model: "blog",
        },
        {
          name: "Floor",
          value: "",
          title: this.$t("edit_bpage_special_info_special.create_store"),
          subtitle: "",
          icon: "sign-yield",
          model: "floor",
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("edit_bpage_special_info_special.user_information"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("edit_bpage_special_info_special.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
      ]; 
    },
      specialInfo2()
      { 
        return [
        {
          name: "PicSelector",
          value: "",
          title: this.$t("edit_bpage_special_info_special.photo_gallery"),
          subtitle: "",
          icon: "image-outline",
          model: "gallery",
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("edit_bpage_special_info_special.video_gallery"),
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "pdfSelector",
          value: "",
          title: this.$t("edit_bpage_special_info_special.pdf_gallery"),
          subtitle: "",
          icon: "file-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("edit_bpage_special_info_special.feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "consultationNew",
          value: "",
          title: this.$t("edit_bpage_special_info_special.request_form"),
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
        },
        {
          name: "ServiceSection",
          value: "",
          title: this.$t("edit_bpage_special_info_special.create_section"),
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: this.$t("edit_bpage_special_info_special.achievements"),
          subtitle: "",
          icon: "bullseye-arrow",
          model: "CounterService",
        },
        {
          name: "Counter",
          value: "",
          title: this.$t("edit_bpage_special_info_special.countdown"),
          subtitle: "",
          icon: "timer-sand",
          model: "Counter",
        },
        {
          name: "Personnel",
          value: "",
          title: this.$t("edit_bpage_special_info_special.team_members"),
          subtitle: "",
          icon: "account-multiple-outline",
          model: "Personnel",
        },
        {
          name: "customerClubSettings",
          title: this.$t(
            "edit_bpage_special_info_special.customer_club_membership_sms"
          ),
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "WorkSheet",
          value: "",
          title: this.$t("edit_bpage_special_info_special.working_hours"),
          subtitle: "",
          icon: "timetable",
          model: "WorkSheet",
        },
        {
          name: "palletCommercial",
          value: "",
          title: this.$t("edit_bpage_special_info_special.select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ];
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    specialInfoSingle() {
  const descriptionKeys = {
    // specialInfo
    bannerSelector:
      "editBpage.special_info_single.banner_selector_description",

    logoSelect:
      "editBpage.special_info_single.logo_select_description",

    Service:
      "editBpage.special_info_single.service_description",

    Faq:
      "editBpage.special_info_single.faq_description",

    Blog:
      "editBpage.special_info_single.blog_description",

    Floor:
      "editBpage.special_info_single.floor_description",

    textCards:
      "editBpage.special_info_single.text_cards_description",

    socialMediaIcons:
      "editBpage.special_info_single.social_media_icons_description",

    // specialInfo2
    PicSelector:
      "editBpage.special_info_single.pic_selector_description",

    VideoGallery:
      "editBpage.special_info_single.video_gallery_description",

    pdfSelector:
      "editBpage.special_info_single.pdf_selector_description",

    FeedBack:
      "editBpage.special_info_single.feedback_description",

    consultationNew:
      "editBpage.special_info_single.consultation_new_description",

    ServiceSection:
      "editBpage.special_info_single.service_section_description",

    CounterService:
      "editBpage.special_info_single.counter_service_description",

    Counter:
      "editBpage.special_info_single.counter_description",

    Personnel:
      "editBpage.special_info_single.personnel_description",

    customerClubSettings:
      "editBpage.special_info_single.customer_club_settings_description",

    WorkSheet:
      "editBpage.special_info_single.work_sheet_description",

    palletCommercial:
      "editBpage.special_info_single.pallet_commercial_description",
  };

  const addDescription = (item) => {
    const descriptionKey =
      descriptionKeys[item.name] ||
      "editBpage.special_info_single.default_description";

    return {
      ...item,
      description: this.$t(descriptionKey, {
        title: item.title || "",
      }),
    };
  };

  return [
    ...this.specialInfo.map(addDescription),
    ...this.specialInfo2.map(addDescription),
  ];
},
  },

  watch: {
    data: {
      deep: true,
      handler(val) {
        console.log("val", val);
      },
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.qrLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}/${!!this.qrId ? this.qrId : ""}`,
        )
        .then(({ data }) => {
          let input = data.data.data.data;
          this.fixData(input);
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          this.data = input;
          this.res = data.data;
          this.fetchStore(data.data.id);
          this.qr_id = data.data.id;

          this.setCreatedQrID(data.data.id);
          this.updateQrId(data.data.id);
          this.setQrType(data.data.type);
          this.setCreatedQrID(data.data.id);
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);
        })
        .finally(() => (this.qrLoading = false));
    },
    async fetchStore(id) {
      await this.$api.get(`/v1/commercial/${id}`).then((data) => {
        this.data.floor.shops = data.data.info;
      });
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "Commericial");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );
      data.append("_method", "PUT");
      localStorage.setItem(
        "test",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );
      this.$api
        .post("/v1/testQr/update", data)
        .then(({ data }) => {
          if(final || !this.AutoSave)
            this.$toast.success("مجتمع تجاری شما با موفقیت ویرایش شد.");
          if(final)
            this.goto("qr/list"); 
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    fixData(input) {
      if (!input.banner) {
        input.banner = {
          gallery: null,
        };
      }
      if (!input.logo) {
        input.logo = {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
        };
      }
      if (!!input.pdfSelector && !input.pdfSelector.layout) {
        input.pdfSelector = {
          ...input.pdfSelector,
          layout: "list",
        };
      }

      if (!input.pdf) input.pdf = null;
      if (!input.blog) input.blog = null;
      if (!input.Floor) input.Floor = { title: "نمایش فروشگاه ها " };
      if (!input.service) input.service = null;
      if (!input.consultationNew || input.consultationNew.length == 0)
        input.consultationNew = {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        };
      if (!input.gallery || input.gallery.length === 0)
        input.gallery = [{ name: "گالری عکس", images: [] }];

      if (!input.video_gallery) input.video_gallery = null;
      if (!input.floor) input.floor = { floors: [], shops: [] };
      if (!input.pallete || Object.keys(input.pallete).length === 0)
        input.pallete = {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        };
      if (!input.them)
        input.them = {
          light: {
            backgroundColor: "#F8FAFC",
            componentsColor: "#9AA6B2",
            textColor: "#000",
            tagColor: "",
            iconColor: "#BCCCDC",
          },
          dark: {
            componentsColor: "#EBD3F8",
            backgroundColor: "#2E073F",
            textColor: "#ffffff",
            iconColor: "#AD49E1",
            tagColor: "",
          },
          mode: "light",
        };
      if (!input.service)
        input.service = [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
      if (!input.blog)
        input.blog = [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ];
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
